import { render, staticRenderFns } from "./EarnWithUpskill.vue?vue&type=template&id=7ecab194&"
import script from "./EarnWithUpskill.vue?vue&type=script&lang=js&"
export * from "./EarnWithUpskill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports